import { DefaultCopyBox, SecondaryButton, styleVariables } from '@lib/common';
import { Modal, Space } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledModal = styled(Modal).withConfig({
  displayName: "share-publish-score-result-modalcomponent__StyledModal",
  componentId: "sc-3j97n0-0"
})(["height:max-content;width:600px !important;margin-block:5em;top:200px;.ant-modal-content{padding:16px;border-radius:16px;border-bottom:none;overflow:hidden;}.ant-modal-body{padding:0 24px;border-bottom:none;}.ant-modal-header{padding:16px 24px 10px 24px;border-bottom:none;}.ant-modal-title{font-size:20px;}.ant-modal-footer{border-top:none;padding:24px;}"]);
var StyledDescription = styled.span.withConfig({
  displayName: "share-publish-score-result-modalcomponent__StyledDescription",
  componentId: "sc-3j97n0-1"
})(["font-size:14px;display:block;margin-bottom:10px;color:", ";"], styleVariables.colors.gray9);
var QrBlock = styled.div.withConfig({
  displayName: "share-publish-score-result-modalcomponent__QrBlock",
  componentId: "sc-3j97n0-2"
})(["margin-top:20px;display:flex;flex-direction:column;align-items:center;gap:8px;"]);
var QrHint = styled.span.withConfig({
  displayName: "share-publish-score-result-modalcomponent__QrHint",
  componentId: "sc-3j97n0-3"
})(["font-size:13px;color:", ";text-align:center;"], styleVariables.colors.gray10);
var QrImage = styled.img.withConfig({
  displayName: "share-publish-score-result-modalcomponent__QrImage",
  componentId: "sc-3j97n0-4"
})(["width:200px;height:200px;border-radius:8px;border:1px solid ", ";"], styleVariables.colors.gray5);
export var SharePublishScoreResultModal = function SharePublishScoreResultModal(props) {
  var isModalVisible = props.isModalVisible,
      sharedLink = props.sharedLink,
      absoluteShareUrl = props.absoluteShareUrl,
      onClose = props.onClose,
      label = props.label;
  var urlToCopy = absoluteShareUrl !== null && absoluteShareUrl !== void 0 ? absoluteShareUrl : sharedLink;
  var copyBoxTranslation = {
    copy: label.copy,
    copied: label.copied
  };
  var qrSrc = absoluteShareUrl && "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=".concat(encodeURIComponent(absoluteShareUrl));

  var renderSharePublishScoreResultContent = function renderSharePublishScoreResultContent() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledDescription, {
        children: label.description
      }), /*#__PURE__*/_jsx(DefaultCopyBox, {
        text: urlToCopy,
        copyBoxTranslation: copyBoxTranslation
      }), qrSrc && /*#__PURE__*/_jsxs(QrBlock, {
        children: [label.qrCodeHint ? /*#__PURE__*/_jsx(QrHint, {
          children: label.qrCodeHint
        }) : null, /*#__PURE__*/_jsx(QrImage, {
          src: qrSrc,
          alt: ""
        })]
      })]
    });
  };

  return /*#__PURE__*/_jsx(StyledModal, {
    title: label.title,
    open: isModalVisible,
    onCancel: onClose,
    footer: /*#__PURE__*/_jsx(Space, {
      direction: "horizontal",
      size: "small",
      children: /*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onClose,
        children: label.close
      })
    }),
    children: renderSharePublishScoreResultContent()
  });
};